import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--cream-white)' }}>
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 
            className="text-2xl font-bold"
            style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)' }}
          >
            Allgemeine Geschäftsbedingungen (AGB)
          </h1>
          <Button 
            variant="outline"
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
            style={{ borderColor: 'var(--warm-gray)', color: 'var(--charcoal)' }}
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Button>
        </nav>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center justify-center mb-8">
          <FileText className="w-16 h-16" style={{ color: 'var(--warm-sage)' }} />
        </div>

        <div className="prose prose-lg max-w-none" style={{ color: 'var(--charcoal)' }}>
          <p className="text-sm mb-8" style={{ color: 'var(--warm-gray)' }}>
            Stand: Januar 2025
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            1. Geltungsbereich
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen zwischen Love Luxe (nachfolgend "Anbieter") und den Kunden. Mit der Nutzung unserer Website und der Kontaktaufnahme erkennen Sie diese AGB an.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            2. Anbieter
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            <strong>Love Luxe</strong><br />
            Zug, Schweiz<br />
            E-Mail: contact@lvluxury.ch<br />
            Telefon: +41 41 543 36 77
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            3. Leistungsumfang
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Der Anbieter vermittelt authentifizierte Louis Vuitton Produkte aus zweiter Hand. Alle auf der Website dargestellten Produkte sind Einzelstücke und unterliegen der Verfügbarkeit. Die Darstellung der Produkte stellt kein rechtlich bindendes Angebot dar, sondern eine unverbindliche Aufforderung zur Kontaktaufnahme.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            4. Vertragsschluss
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Ein Kaufvertrag kommt erst durch individuelle Vereinbarung zwischen dem Anbieter und dem Kunden zustande. Die Kontaktaufnahme über das Kontaktformular oder per E-Mail stellt lediglich eine unverbindliche Anfrage dar. Der Anbieter bestätigt den Eingang der Anfrage und unterbreitet gegebenenfalls ein verbindliches Angebot.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            5. Preise und Zahlungsbedingungen
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Alle Preise verstehen sich in Schweizer Franken (CHF) und sind Endpreise. Die genauen Zahlungsmodalitäten werden individuell mit dem Kunden vereinbart. Akzeptierte Zahlungsmethoden umfassen TWINT, Banküberweisung und weitere nach Vereinbarung.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            6. Authentifizierung und Produktzustand
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Alle angebotenen Produkte wurden von Experten auf Echtheit geprüft. Der Zustand jedes Produkts wird ehrlich und detailliert beschrieben. Gebrauchsspuren entsprechen dem Charakter von Second-Hand-Luxusartikeln und stellen keinen Mangel dar, sofern sie in der Produktbeschreibung erwähnt wurden.
          </p>

          <h2 id="lieferung-versand" style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            7. Lieferung und Versand
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Die Lieferung erfolgt nach individueller Vereinbarung. Der Versand wird versichert durchgeführt. Die Versandkosten und Lieferzeiten werden vor Vertragsabschluss mitgeteilt.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            8. Rückgabe und Umtausch
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Da es sich um individuelle Second-Hand-Artikel handelt, werden Rückgabe- und Umtauschbedingungen einzeln mit jedem Kunden vereinbart. Bitte kontaktieren Sie uns vor einem Kauf, um die Konditionen zu besprechen.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            9. Haftung
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Der Anbieter haftet für Vorsatz und grobe Fahrlässigkeit. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit oder aus der Verletzung wesentlicher Vertragspflichten betroffen sind.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            10. Urheberrecht
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Alle Inhalte dieser Website (Texte, Bilder, Grafiken) sind urheberrechtlich geschützt. Die Verwendung ohne ausdrückliche Genehmigung des Anbieters ist untersagt.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            11. Anwendbares Recht und Gerichtsstand
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Es gilt ausschliesslich schweizerisches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist Zug, Schweiz.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            12. Salvatorische Klausel
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Die unwirksame Bestimmung wird durch eine wirksame ersetzt, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            13. Kontakt
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Bei Fragen zu diesen AGB kontaktieren Sie uns bitte:<br /><br />
            E-Mail: contact@lvluxury.ch<br />
            Telefon: +41 41 543 36 77
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
